import { ApplicationRef, inject, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { NzModalService } from 'ng-zorro-antd/modal';
import { interval } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class UpdateService {
    private swUpdate = inject(SwUpdate);
    private appRef = inject(ApplicationRef);
    private modal = inject(NzModalService);
    private update = true;

    constructor() {
        console.log('INIT UPDATER');
        if (!this.swUpdate.isEnabled) return;

        console.log('INIT swUpdate ENABLED');

        const interval$ = interval(1 * 60 * 1000); //Every minute
        
        // Checks for updates every minute
        interval$.subscribe(() => {
            console.log('CHECK UPDATE');
            const isAnyUpdate = this.swUpdate.checkForUpdate();
            console.log('ANY UPDATE? ', isAnyUpdate);
        });

        // When a new version is detected
        this.swUpdate.versionUpdates.subscribe((event) => {
            console.log('NEW UPDATE ', event);
            if (event.type === 'VERSION_READY' && this.update) {
                this.promptUser();
            }
        });
    }

    private promptUser(): void {
        const ref = this.modal.confirm({
            nzTitle: '¡Nueva versión disponible!',
            nzContent: '¿Quieres actualizar ahora?',
            nzOkText: 'Actualizar',
            nzCancelText: 'Más tarde',
            nzOnOk: () => this.doUpdate(),
            nzOnCancel: () => {
                this.update = false;
            }
        });

        // If there is no response within 60 seconds, it performs the update automatically
        setTimeout(() => {
            console.log('CLOSE MODAL & UPDATE');
            ref.close();
            this.doUpdate();
        }, 60000);
    }

    private doUpdate(): void {
        console.log('DO UPDATE');
        if(this.update){
            this.swUpdate.activateUpdate().then(() =>{
                location.reload();
            });
        }
    }
}
